import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@mui/material';

import { Typography, Card, CardHeader, CardContent } from '@occc-app/design-system';
import { State as RootState } from '@occc-app/rootRedux';
import { State as ProductGroupsState } from '@occc-app/Offer/ProductGroups/redux';

import { actions } from './redux';
import { AudiencesSummary } from './components/AudiencesSummary';
import { ConstraintsSummary } from './components/ConstraintsSummary';
import { EarningMechanismSummary } from './components/EarningMechanismSummary';
import { LimitsSummary } from './components/LimitsSummary';
import { MarketingContentSummary } from './components/MarketingContentSummary';
import { MetaDataConfigurationSummary } from './components/MetaDataConfigurationSummary';

type ComponentState = RootState['offer'] & {
  productGroups: ProductGroupsState['data']['productGroups'];
};
type Actions = typeof actions;
type Props = Actions & ComponentState;

class Summary extends React.Component<Props, {}> {
  renderSummaries() {
    const { audiences, constraints, earningMechanisms, limits, productGroups } = this.props;

    return (
      <Box>
        <EarningMechanismSummary
          earningMechanisms={earningMechanisms}
          productGroups={productGroups}
        />

        <ConstraintsSummary constraints={constraints} />

        <LimitsSummary limits={limits} requiresActivation={constraints.requiresActivation.active} />

        <AudiencesSummary audiences={audiences} />
      </Box>
    );
  }

  renderMetaDataFields() {
    const metaDataProps = {
      ...this.props.metaData,
      fieldDisabled: () => false,
    };

    return <MetaDataConfigurationSummary {...metaDataProps} />;
  }

  renderOfferDescription() {
    const {
      getStarted: { offerDescription },
    } = this.props;

    if (!offerDescription) {
      return;
    }

    return (
      <Card>
        <CardHeader title={this.renderDescriptionTitle()} />
        <CardContent>
          <Typography>{offerDescription}</Typography>
        </CardContent>
      </Card>
    );
  }

  render() {
    return (
      <Box component='section'>
        {this.renderOfferDescription()}
        <Card variant='outlined'>
          <CardHeader title={this.renderTitle()} />
          <CardContent>{this.renderSummaries()}</CardContent>
        </Card>
        <Card variant='outlined'>
          <CardHeader title={this.renderMarketingContentTitle()} />
          <CardContent>
            <MarketingContentSummary {...this.props.marketingContent} />
          </CardContent>
        </Card>
        <Card variant='outlined' style={{ overflow: 'visible' }}>
          <CardHeader title={this.renderMetaDataTitle()} />
          <CardContent>{this.renderMetaDataFields()}</CardContent>
        </Card>
      </Box>
    );
  }
  renderDescriptionTitle() {
    return (
      <Typography component='h4' variant='h6'>
        Here's what you set out to do:
      </Typography>
    );
  }
  renderTitle() {
    return (
      <Typography component='h4' variant='h6'>
        Here's what you configured in Activate:
      </Typography>
    );
  }
  renderMarketingContentTitle() {
    return (
      <Typography component='h4' variant='h6'>
        Here's what member might see:
      </Typography>
    );
  }
  renderMetaDataTitle() {
    return (
      <Typography component='h4' variant='h6'>
        Does that look OK? Let's finish up:
      </Typography>
    );
  }
}

type MapStateToProps = (state: RootState) => ComponentState;
const mapStateToProps: MapStateToProps = ({
  offer,
  productGroups: {
    data: { productGroups },
  },
}) => ({ ...offer, productGroups });
export default connect(mapStateToProps, actions)(Summary);
